// extracted by mini-css-extract-plugin
export var animationNum = "index-module--animationNum--1i3e3";
export var contentContainer = "index-module--contentContainer--2q59y";
export var desc = "index-module--desc--RSCZy";
export var listOneItem = "index-module--listOneItem--szgtm";
export var listOneMb = "index-module--listOneMb--3msEy";
export var number = "index-module--number--6tC32";
export var numberContainer = "index-module--numberContainer--YUVkm";
export var text = "index-module--text--NoFe4";
export var unit = "index-module--unit--1V0d3";